// extracted by mini-css-extract-plugin
export default {"modal":"OutdatedStockModal_modal__ZPzBG","container":"OutdatedStockModal_container__cqYxu","button":"OutdatedStockModal_button__KNqsA"};